// Pasarelas de cobro en línea que el admin puede configurar en Ajustes.
// Qué existe y qué pide cada una; qué está OPERATIVO lo decide el backend
// (functions/pasarelas/registro.js) y llega en el estado. Mismos campos que
// functions/credencialesIntegracion.js.
export const ENTORNOS_PASARELA = Object.freeze({ pruebas: 'Pruebas', produccion: 'Producción' });

/** Mercado Pago: el User ID es el número final del Access Token (APP_USR-…-123456789). */
export const userIdDeAccessToken = (token) => /^(?:APP_USR|TEST)-.*-(\d{5,15})$/.exec(String(token || '').trim())?.[1] || '';

// webhook: 'panel' = el admin pega la URL de notificaciones en el panel del
// proveedor; 'automatico' = AllGym la envía con cada pago (Izipay).
// guia: pasos para que el propio admin conecte su cuenta, sin soporte.
export const PASARELAS = Object.freeze([
  {
    id: 'mercadopago', nombre: 'Mercado Pago',
    descripcion: 'Yape con código de aprobación dentro de tu tienda, y tarjetas en el checkout de Mercado Pago.',
    donde: 'Mercado Pago Developers › Tus integraciones › tu aplicación › Credenciales de producción.',
    campos: [
      { id: 'publicKey', etiqueta: 'Public Key' },
      { id: 'accessToken', etiqueta: 'Access Token', secreto: true },
      { id: 'sellerId', etiqueta: 'User ID del vendedor', modo: 'numeric' },
      { id: 'webhookSecret', etiqueta: 'Clave secreta del webhook', secreto: true, opcional: true },
    ],
    // webhookOpcional: cada cobro lleva su URL de avisos; la del panel y la clave son un extra.
    webhook: 'panel', eventoWebhook: 'Pagos', webhookOpcional: true,
    guia: {
      titulo: 'Cómo conectar Mercado Pago (unos 10 minutos)', enlace: 'https://www.mercadopago.com.pe/developers/panel/app', textoEnlace: 'Mercado Pago Developers',
      pasos: [
        ['Crea la aplicación.', 'Entra a Mercado Pago Developers con la cuenta que recibirá el dinero › Tus integraciones › Crear aplicación › Crear en el panel de integración › Checkout API, con Tipo de API «API de Payments».'],
        ['Pruebas.', 'En tu aplicación › Cuentas de prueba, crea un vendedor y un comprador de Perú. Copia la Public Key y el Access Token de pruebas (empiezan con APP_USR) y el User ID del vendedor de prueba.'],
        ['Guarda y activa Pruebas.', 'Pega la Public Key y el Access Token en «Configurar» de Pruebas, guarda y pulsa Activar. Compra en tu catálogo con el comprador de prueba: el pedido debe pasar solo a «Preparando».'],
        ['Producción.', 'En tu aplicación › Credenciales de producción, actívalas (te piden rubro y sitio web: usa la dirección de tu catálogo). Copia la Public Key y el Access Token (el User ID se completa solo al pegarlo), pégalos en «Configurar» de Producción, guarda y pulsa Activar.'],
      ],
      nota: 'Mercado Pago cobra su comisión por venta y devuelve el dinero por API desde el pedido.',
    },
  },
  {
    id: 'culqi', nombre: 'Culqi',
    descripcion: 'Tarjetas (con 3DS), Yape, billeteras y pago en agentes con tu cuenta Culqi.',
    donde: 'CulqiPanel › Desarrollo › API Keys.',
    campos: [
      { id: 'publicKey', etiqueta: 'Llave pública (pk_…)' },
      { id: 'secretKey', etiqueta: 'Llave secreta (sk_…)', secreto: true },
    ],
    webhook: 'panel', eventoWebhook: 'cargos y órdenes',
    guia: {
      titulo: 'Cómo conectar Culqi (unos 15 minutos)', enlace: 'https://panel.culqi.com', textoEnlace: 'CulqiPanel',
      pasos: [
        ['Afíliate.', 'Crea tu cuenta de comercio en Culqi y entra a CulqiPanel.'],
        ['Pruebas.', 'En Desarrollo › API Keys copia la llave pública (pk_test_…) y la secreta (sk_test_…) y pégalas en «Configurar» de Pruebas.'],
        ['Eventos (webhook).', 'En Desarrollo › Eventos agrega la URL de este entorno (la verás al configurar abajo) para los eventos de cargos y órdenes. Así se confirman los pagos con billetera o en agentes.'],
        ['Activa Pruebas.', 'Compra en tu catálogo con una tarjeta de prueba de Culqi: el pedido debe pasar solo a «Preparando».'],
        ['Producción.', 'Cuando Culqi active tu cuenta, copia las llaves pk_live_ y sk_live_, agrega el evento de producción y activa Producción.'],
      ],
      nota: 'Culqi pide el correo del comprador: el carrito lo solicita automáticamente. Las devoluciones con tarjeta se hacen desde el pedido; las de billetera o agente, en CulqiPanel.',
    },
  },
  {
    id: 'izipay', nombre: 'Izipay',
    descripcion: 'Formulario de pago oficial de Izipay: tarjetas, Yape y Plin.',
    donde: 'Panel de Izipay › Desarrolladores › Claves.',
    campos: [
      { id: 'merchantCode', etiqueta: 'Código de comercio' },
      { id: 'apiKey', etiqueta: 'Clave de API', secreto: true },
      { id: 'hashKey', etiqueta: 'Clave hash', secreto: true },
      { id: 'publicKeyRsa', etiqueta: 'Clave pública RSA', multilinea: true },
    ],
    webhook: 'automatico',
    guia: {
      titulo: 'Cómo conectar Izipay (unos 10 minutos)', enlace: 'https://sandbox-panel.izipay.pe/', textoEnlace: 'panel de integración de Izipay',
      pasos: [
        ['Afíliate.', 'Contrata los pagos en línea con Izipay: te enviarán el usuario y la contraseña de su panel.'],
        ['Pruebas.', 'En el panel de integración › Desarrolladores › Claves copia el código de comercio, la clave de API, la clave hash y la clave pública RSA, y pégalos en «Configurar» de Pruebas.'],
        ['Notificaciones.', 'No necesitas configurar nada: AllGym envía su URL con cada pago.'],
        ['Activa Pruebas.', 'Compra en tu catálogo con una tarjeta de prueba de Izipay: el pedido debe pasar solo a «Preparando».'],
        ['Producción.', 'Repite con las claves del panel de producción (panel.izipay.pe) y activa Producción.'],
      ],
      nota: 'Izipay no permite devolver por API: devuelve desde su panel y registra la devolución en el pedido. Para liberar una reserva sin pago, confirma «No hubo pago» tras revisar su panel.',
    },
  },
]);

export const nombrePasarela = (id) => PASARELAS.find((p) => p.id === id)?.nombre || id;

/** Texto del modo de cobro actual del catálogo. */
export const etiquetaCobroActivo = (activo) => (activo
  ? `${nombrePasarela(activo.proveedor)} · ${ENTORNOS_PASARELA[activo.entorno] || activo.entorno}`
  : 'Manual (Yape, Plin, transferencia o efectivo)');

/** Credenciales completas según los campos de la pasarela (sin validar formato: lo hace el backend). */
export const credencialesCompletas = (pasarela, valores = {}) =>
  pasarela.campos.every((c) => c.opcional || String(valores[c.id] || '').trim().length > 0);

// Modo de cobro de un pedido o catálogo (mismo criterio que functions/pasarelas/modosCobro.js).
export const MODOS_COBRO_AUTOMATICO = Object.freeze({ automatico_pruebas: 'pruebas', automatico_produccion: 'produccion' });
export const esCobroAutomatico = (modo) => Object.prototype.hasOwnProperty.call(MODOS_COBRO_AUTOMATICO, modo);
/** Entorno de la pasarela de un pedido: su modo automático o el de un checkout vinculado. */
export const entornoPedido = (orden) => MODOS_COBRO_AUTOMATICO[orden?.modoCobro] || orden?.pasarela?.entorno || null;

/** funcionalidades.cobroCatalogo ('manual' | '{proveedor}_{entorno}') → { proveedor, entorno } o null. */
export const cobroActivo = (cobroCatalogo) => {
  const [proveedor, entorno, ...resto] = String(cobroCatalogo || 'manual').split('_');
  return !resto.length && PASARELAS.some((p) => p.id === proveedor) && ENTORNOS_PASARELA[entorno] ? { proveedor, entorno } : null;
};

/** Con Mercado Pago activo (superadmin + Ajustes del admin), el socio renueva en línea desde su app. */
export const renuevaEnLinea = (funcionalidades) => funcionalidades?.modulos?.pasarelaPagos === true
  && cobroActivo(funcionalidades?.cobroCatalogo)?.proveedor === 'mercadopago';
